import apiBase from './api';

import mockBecas from './becas.json';

const api = Object.assign({}, apiBase, {
  uri: {
    cursos: 'secure/becas/cursos',
    aspirantes: 'secure/becas/aspirantes'
  }
});

api.getCourses = async function () {
  const courses = mockBecas;

  return courses
  .map((course) => {
    const social = course.contacto.map()
  })
  .map((course) => {
    const minAge = parseInt(course.edadMinima, 10);
    const maxAge = parseInt(course.edadMaxima, 10)
    return {
      id: course.id,
      school: course.institucion || '',
      email: course.email,
      name: course.nombre,
      schedule: course.horarios,
      description: course["descripción"],
      level: course.nivel,
      price: course.precio,
      minAge: isNaN(minAge) ? 0 : minAge,
      maxAge: isNaN(maxAge) ? 100 : maxAge,
      facebook: course.facebook,
      web: course.web,
      instagram: course.instagram,
      twitter: course.twitter
    }
  }).slice(1);
}

export default api;


// WEBPACK FOOTER //
// ./src/utils/api/mock_api.js